module.exports = __webpack_public_path__ + "img/Avatar-37.eb4c4f18.svg";